export const importanceRateConvertFromEnToFa = (abundanceRate) => {
    switch (abundanceRate) {
        case 'HIGH':
            return 'زیاد'
        case 'MEDIUM':
            return 'متوسط'
        case 'LOW':
            return 'کم'
        default:
            return 'نامشخص'
    }
}

export const attackImpactRateConvertor = (attackImpactRate) => {
    switch (attackImpactRate) {
        case 1:
            return 'بالای 80 درصد'
        case 2:
            return 'بین 60 تا 80 درصد'
        case 3:
            return 'بین 40 تا 60 درصد'
        case 4:
            return 'بین 20 تا 40 درصد'
        case 5:
            return 'زیر 20 درصد'
        default:
            return 'زیر 5 درصد'
    }
}

export const placingDataForEachElementBoxInEachPageUiHelper = (numberOfDynamicPagesLength, i) => {
    if (numberOfDynamicPagesLength === 1 && i === 0) {
        return { showPrescriptionElementBox1: true, showPrescriptionElementBox2: true, showPrescriptionElementBox3: true }
    }
    if (numberOfDynamicPagesLength === 2 && i === 0) {
        return { showPrescriptionElementBox1: true, showPrescriptionElementBox2: true, showPrescriptionElementBox3: false }
    }
    if (numberOfDynamicPagesLength === 2 && i === 1) {
        return { showPrescriptionElementBox1: false, showPrescriptionElementBox2: false, showPrescriptionElementBox3: true }
    }
    if (numberOfDynamicPagesLength === 3 && i === 0) {
        return { showPrescriptionElementBox1: true, showPrescriptionElementBox2: false, showPrescriptionElementBox3: false }
    }
    if (numberOfDynamicPagesLength === 3 && i === 1) {
        return { showPrescriptionElementBox1: false, showPrescriptionElementBox2: true, showPrescriptionElementBox3: false }
    }
    if (numberOfDynamicPagesLength === 3 && i === 2) {
        return { showPrescriptionElementBox1: false, showPrescriptionElementBox2: false, showPrescriptionElementBox3: true }
    }
}